import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IPlayerChapter } from './chapters/IPlayerChapter';
import { IScrubAdapter } from './scrubAdapter/IScrubAdapter';

import { VideogularComponent } from '../Videogular.Component';

@Component({
	selector: 'vb-scrub-bar-with-chapters',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		@for (chapter of chapters; track chapter; let i = $index; let isLast = $last) {
			<vb-scrub-bar-chapter
				[adapter]="adapter"
				[chapter]="chapter"
				[nextChapter]="chapters[i + 1]"
				[isLast]="isLast">
			</vb-scrub-bar-chapter>
		}
	`,
	standalone: false,
	styleUrls: ['./VbScrubBarWithChapters.Component.ng.less']
})
export class VbScrubBarWithChaptersComponent {
	@Input() public chapters: IPlayerChapter[];
	@Input() public adapter: IScrubAdapter;

	constructor(
		public vgApi: VideogularComponent
	) {}

}
